import React, { useContext, useEffect, useRef, useState } from "react";
import AdvertisementCard from "./AdvertisementCard";
import { ErrorMessage, Form, Formik } from "formik";
import SidebarField from "../../components/Sidebar/SidebarField";
import { LuEye } from "react-icons/lu";
import { PiShareFat } from "react-icons/pi";
import { MdDownloadDone, MdOutlineShoppingCart, MdEdit } from "react-icons/md";
import { Line } from "react-chartjs-2";
import BreadCrumb from "../../components/BreadCrumb";
import Button from "../../components/Button";
import promoimg from "../../assest/offer_promo.png";
import Lable from "../../components/Lable";
import TextInput from "../../components/TextInput";
import { Dropdown } from "primereact/dropdown";
import LoadingContext from "../../components/loader/index";
import { productApi } from "../../apis/ProductListing.apis";
import { toast } from "react-toastify";
import CalendarComp from "../../components/CalendarComp/CalendarComp";
import moment from "moment/moment";
import { AdvertisementApi } from "../../apis/Advertisement.apis";
import DeleteFieldModal from "../../components/DeleteFieldModal";
import { useSelector } from "react-redux";
import validationSchema from "./ValidationSchema";
import ImagePreview from "../../components/ImagePreview";
import { Calendar } from "primereact/calendar";
import { GiClick } from "react-icons/gi";

function PromoManagement() {
  const [adData, setAdData] = useState([]);
  const [dailyBudgetEditable, setDailyBudgetEditable] = useState(false);
  const [remainingBudgetEditable, setRemainingBudgetEditable] = useState(false);
  const currentUser = useSelector((state) => state.store);
  const deliveryBusiness = currentUser?.currentUser?.delivery_business?.name;
  const [audienceType, setAudienceType] = useState("");
  console.log("audienceType:", audienceType);

  const { handleLoading } = useContext(LoadingContext);
  const chartRef = useRef(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isAdvertisementModel, setIsAdvertisementModel] = useState(false);
  const [singleAdd, setSingleAdd] = useState({
    _id: 1,
    image: promoimg,
    advertisement_for: "product",
    product: "",
    duration: 0,
    audience_type: "",
    target_audience_age: 0,
    location_radius: 0,
    gender: "",
    start_date: null,
    end_date: null,
    advertisement_budget: 0,
    advertisement_tax: 0,
    advertise_views: 0,
    ordered_by_advertise: 0,
    addToCart_count: 0,
    share: 0,
  });

  const [adPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  // const handlePagination = (data) => {
  //   console.log(data);
  //   if (data.clearPagination) {
  //     setAdPagination(data.clearPagination);
  //     return;
  //   }
  //   setAdPagination((prev) => {
  //     let copyfilter = { ...prev.filter };
  //     // copyfilter[]

  //     if (data.filter) {
  //       // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
  //       // console.log("Object.keys[copyfilter]",Object.keys(data.filter))

  //       if (copyfilter[Object.keys(data.filter)[0]]) {
  //         copyfilter[Object.keys(data.filter)[0]] = Object.values(
  //           data.filter
  //         )[0];
  //       } else {
  //         copyfilter = { ...data?.filter, ...copyfilter };
  //       }
  //     }

  //     return {
  //       page: data.page ? data.page : prev.page,
  //       limit: data.limit ? data.limit : prev.limit,
  //       sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
  //       filter: copyfilter,
  //     };
  //   });
  // };

  useEffect(() => {
    if (isAdvertisementModel) {
      // When editing existing ad → start disabled
      // When creating new ad → start enabled
      setDailyBudgetEditable(!singleAdd?._id);
      setRemainingBudgetEditable(false); // recharge only for existing ads
    } else {
      // Optional: reset when modal closes
      setDailyBudgetEditable(false);
      setRemainingBudgetEditable(false);
    }
  }, [isAdvertisementModel, singleAdd?._id]);

  const beforeMount = async () => {
    handleLoading(true);
    try {
      //get all advertisement details
      const resAddData =
        await AdvertisementApi.getAllAdvertisement(adPagination);
      console.log("all Advertisement", resAddData.data.data?.advertisements);
      setAdData(resAddData.data.data?.advertisements);
      handlePromoForOption();
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      handleLoading(false);
    }
  };

  useEffect(() => {
    beforeMount();
  }, []);

  const handleEditOpen = (value) => {
    setIsAdvertisementModel(true);
    setSingleAdd(value);
  };

  //delete advertisement
  const handleDeleteOffer = (value) => {
    console.log(value);
    setSingleAdd(value);
    setDeleteModal(true);
  };

  const handleDeleteClose = () => {
    setDeleteModal(false);
  };
  const handleDelete = async () => {
    handleLoading(true);

    try {
      let res;

      if (singleAdd._id) {
        res = await AdvertisementApi.deleteAdvertisement(singleAdd._id);
        toast.success(`${res.data.data}`);
        beforeMount();
      }

      console.log(res);
    } catch (err) {
      console.log(err);
      // toast.error(`${err.message}`)
    } finally {
      setAdData({});
      handleLoading(false);
      handleDeleteClose();
    }
  };

  const handleClose = () => {
    setIsAdvertisementModel(false);
    setAudienceType();
  };
  const handleSubmit = async (values) => {
    console.log("Advertisement Submit:", values);
    handleLoading(true);
    try {
      const res = singleAdd?.product
        ? await AdvertisementApi.updateAdvertisement(values, singleAdd._id)
        : await AdvertisementApi.createAdvertisement(values);
      console.log("res", res);
      await beforeMount();
      setIsAdvertisementModel(false);
      toast.success(
        singleAdd?.product
          ? "Your Advertisement updated"
          : "New Advertisement Created",
      );
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setAudienceType();
      handleLoading(false);
    }
    handleClose();
  };

  const data = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Views",
        data: [35000, 22000, 80000, 15000, 56000, 11000, 40000],
        fill: false,
        backgroundColor: "rgba(10,255,10,0.4)",
        borderColor: "rgba(10,255,10,1)",
      },
      {
        label: "Orders",
        data: [32000, 32000, 10000, 95000, 19000, 11800, 10000],
        fill: false,
        backgroundColor: "rgba(255, 0, 0, 0.4)",
        borderColor: "rgba(255, 0, 0,1)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
      },
      y: {
        display: true,
      },
    },
  };

  // const getSingleSelectValue = (value) => {
  //   console.log("value", value);

  //   if (value && value.length) {
  //     // values.promo_for==="Category"?"category":values.promo_for==="Sub Category"?"sub_category":"product"
  //     const selectedId = value?.map((item) => {
  //       if (item.id) {
  //         return item.id;
  //       } else {
  //         return item;
  //       }
  //     });
  //     return selectedId;
  //   } else {
  //     return null;
  //   }
  // };

  const fetchingPromoforOptions = async () => {
    console.log("2nd stage of product fetch is");

    handleLoading(true);

    try {
      // if (promoFor === "Category") {
      //   const resCategory = await CategoryApi.getCategory();
      //   return resCategory.data?.data;
      //   // setCategoryData(resCategory.data?.data);
      // }
      // if (promoFor === "Sub Category") {
      //   const resSubCategory = await SubCategoryApi.getSubCategory();
      //   return resSubCategory.data?.data;
      //   // setSubCategoryData(resSubCategory.data?.data)
      // }

      // if (promoFor === "product") {
      const resProduct =
        deliveryBusiness === "Ecommerce"
          ? await productApi.getAllProducts()
          : await productApi.getAllFoodProduct();
      console.log(
        `${
          deliveryBusiness === "Ecommerce"
            ? "get all product result:"
            : "get all Food product result:"
        }`,
        resProduct.data?.data,
      );

      return resProduct.data?.data;
      // setPromocodeData(resProduct.data?.data)
      // }
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      handleLoading(false);
    }
  };
  const [optionPromoFor, setOptionPromoFor] = useState([]);

  const handlePromoForOption = async () => {
    console.log("handlePromoForOption is Executing");

    // const data = await fetchingPromoforOptions();
    // console.log("Product data",deliveryBusiness==="Ecommerce"?data?.products:data);
    // const option =
    //   data &&
    //   data?.products?.length &&
    //   data?.products?.map((d) => {
    //     d.label = d.name;
    //     d.value = d._id;
    //     return d;
    //   });
    // console.log(option);

    // setOptionPromoFor(option ? option : []);

    const data = await fetchingPromoforOptions();
    console.log(
      "Product data",
      deliveryBusiness === "Ecommerce" ? data?.products : data,
    );

    const option = data
      ? deliveryBusiness === "Ecommerce"
        ? data?.products?.map((d) => {
            d.label = d.name;
            d.value = d._id;
            return d;
          })
        : data?.map((d) => {
            d.label = d.businessName; // Assuming a different property exists for non-Ecommerce
            d.value = d._id;
            return d;
          })
      : [];

    console.log(option);

    setOptionPromoFor(option.length ? option : []);
  };

  const [error, setError] = useState("");

  const handleFileUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    console.log("image from advertisement", file);

    if (file) {
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 5) {
        setError("Please select an image smaller than 5MB.");
        setFieldValue("image", null);
        return;
      } else {
        setError("");
        setFieldValue("image", file);
        console.log("imageUrl:", file);
      }
    }
  };

  return (
    <div className="pt-4 mr-6 ">
      <div className="flex justify-between items-center flex-wrap m-4 border-b">
        <BreadCrumb title="Advertisement" />

        <Button
          text="Add New"
          type="button"
          className="float-end"
          onClick={() => handleEditOpen(null)}
        />
      </div>
      <div className="grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 mt-5 gap-3">
        {adData.length
          ? adData?.map((data, i) => (
              <AdvertisementCard
                adData={data}
                key={i}
                handleEditOpen={handleEditOpen}
                handleClose={handleClose}
                handleDelete={handleDeleteOffer}
              />
            ))
          : "No advertise is Created yet"}

        {isAdvertisementModel && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              image: singleAdd?.image || "",
              // title: singleAdd?.title || "",
              advertisement_for: singleAdd?.advertisement_for || "product",
              product: singleAdd?.product || null,
              duration: singleAdd?.duration || 0,
              start_date: singleAdd?.start_date || "",
              end_date: singleAdd?.end_date || "",
              audience_type: singleAdd?.audience_type || "",
              target_audience_age: singleAdd?.target_audience_age || 0,
              location_radius: singleAdd?.location_radius || 0,
              gender: singleAdd?.gender || "All",
              // audience_count: singleAdd?.audience_count || 9,
              advertisement_budget: singleAdd?.advertisement_budget || 0,
              remaining_budget: singleAdd?.remaining_budget || 0,
              advertisement_tax: singleAdd?.advertisement_tax || 50,
              advertise_views: singleAdd?.advertise_views || 0,
              ordered_by_advertise: singleAdd?.ordered_by_advertise || 0,
              addToCart_count: singleAdd?.addToCart_count || 0,
              share: singleAdd?.share || 0,
            }}
            onSubmit={handleSubmit}
            // validationSchema={validationSchema}
          >
            {({ handleChange, setFieldValue, values, handleSubmit }) => (
              <Form>
                <SidebarField
                  handleClose={handleClose}
                  title_style="text-RedColor text-2xl"
                  title={
                    singleAdd?.product
                      ? "Update Advertisement"
                      : "Create Advertisement"
                  }
                  button1={
                    <Button text="Cancel" type="button" onClick={handleClose} />
                  }
                  button2={
                    <Button
                      text={singleAdd?.product ? "Update" : "submit"}
                      type="submit"
                      onClick={handleSubmit}
                    />
                  }
                >
                  <div className="p-2 text-lg">
                    <div className="relative h-fit w-[95%] shadow-xl rounded-xl m-auto">
                      <label
                        htmlFor="image-upload"
                        className="absolute right-1 top-1 p-2 bg-buttonColor rounded-full cursor-pointer text-secondaryColor"
                      >
                        <input
                          type="file"
                          id="image-upload"
                          accept="image/*"
                          onChange={(e) => handleFileUpload(e, setFieldValue)}
                          // onChange={(e)=>imageCheck(e)}
                          // value={values.image}
                          name="image"
                          style={{ display: "none" }}
                        />
                        <MdEdit />
                      </label>
                      {typeof values.image === "object" ? (
                        <ImagePreview file={values.image} Id="promo" />
                      ) : (
                        <img
                          src={values.image || promoimg}
                          alt="Promo Not Found"
                        />
                      )}
                    </div>
                    {error && (
                      <p className="text-RedColor text-sm mt-2">{error}</p>
                    )}
                    <ErrorMessage
                      name="image"
                      component="div"
                      className="error"
                    />
                    <div className="">
                      {values.advertisement_for &&
                        values.advertisement_for === "product" && (
                          <div className="my-2">
                            <Lable lable={`${values.advertisement_for}`} />

                            <div className="border">
                              <Dropdown
                                value={values.product}
                                onChange={(e) =>
                                  setFieldValue(
                                    values.advertisement_for,
                                    e.value,
                                  )
                                }
                                options={
                                  optionPromoFor.length ? optionPromoFor : []
                                }
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Select a Product for Advertisement"
                                className="w-full"
                              />
                            </div>

                            <ErrorMessage
                              name="advertisement_for"
                              component="div"
                              className="error"
                            />
                          </div>
                        )}

                      <div className="my-2">
                        <div className="flex">
                          <Lable lable="Advertisement Duration" />
                        </div>

                        {singleAdd?._id ? (
                          <Calendar
                            name="dateRange"
                            value={[
                              values.start_date
                                ? new Date(values.start_date)
                                : null,
                              values.end_date
                                ? new Date(values.end_date)
                                : null,
                            ]}
                            onChange={(e) => {
                              if (e.value && Array.isArray(e.value)) {
                                const [start, end] = e.value; // Destructure start and end dates
                                setFieldValue(
                                  "start_date",
                                  start ? start.toISOString() : null,
                                );
                                setFieldValue(
                                  "end_date",
                                  end ? end.toISOString() : null,
                                );
                              }
                            }}
                            selectionMode="range"
                            readOnlyInput
                            hideOnRangeSelection
                            className="border w-full"
                          />
                        ) : (
                          <CalendarComp
                            className="w-full border-[#e5e7eb]"
                            showTime
                            hourFormat="12"
                            sx={{
                              width: "100%",
                              height: "2.5rem",
                            }}
                            value={[
                              values.start_date
                                ? new Date(values.start_date)
                                : null,
                              values.end_date
                                ? new Date(values.end_date)
                                : null,
                            ]}
                            handleFilter={(type, v) => {
                              if (v && v.length === 2) {
                                const formattedDates = v.map((date) =>
                                  moment(date)
                                    .utc()
                                    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                                );
                                setFieldValue("start_date", formattedDates[0]);
                                setFieldValue("end_date", formattedDates[1]);
                              }
                            }}
                          />
                        )}
                        {/* <ErrorMessage
                          name="dateRange"
                          component="div"
                          className="error"
                        /> */}
                      </div>
                      <div className="flex justify-between gap-2 my-2">
                        <div className="w-[100%]">
                          <div className="flex">
                            <Lable lable="Audience Type" />
                          </div>
                          <div className="border">
                            <Dropdown
                              className="w-full border"
                              value={values.audience_type}
                              onChange={(e) => {
                                setAudienceType(e.value);
                                setFieldValue("audience_type", e.value);
                                console.log(
                                  "Audience type:",
                                  values.audience_type,
                                );
                              }}
                              options={[
                                { name: "Suggested", value: "Suggested" },
                                {
                                  name: "Own Audience",
                                  value: "Own Audience",
                                },
                              ]}
                              optionLabel="name"
                              placeholder="Select Audience Type"
                            />

                            {/* <Dropdown
                              className="w-full"
                              options={[
                                { label: "Suggested", value: "Suggested" },
                                {
                                  label: "Own Audience",
                                  value: "Own Audience",
                                },
                              ]}
                              name="audience_type"
                              value={audienceType}
                              onChange={setAudienceType(values.audience_type)}
                            /> */}
                          </div>
                          <ErrorMessage
                            name="discount_type"
                            component="div"
                            className="error"
                          />
                        </div>
                      </div>
                      {values.audience_type === "Own Audience" && (
                        <div className="border border-gray-200 rounded-lg p-5 bg-white shadow-sm mb-6">
                          {/* Section Header */}
                          <div className="mb-4">
                            <h3 className="text-lg font-semibold text-gray-800">
                              Target Your Own Audience
                            </h3>
                            <p className="text-sm text-gray-500 mt-1">
                              Narrow down who sees your advertisement
                            </p>
                          </div>

                          {/* Form Fields - Better spacing & layout */}
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                            {/* Age */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                Minimum Age
                              </label>
                              <div className="relative">
                                <input
                                  type="number"
                                  name="target_audience_age"
                                  placeholder="e.g. 20"
                                  value={values.target_audience_age || ""}
                                  onChange={handleChange}
                                  min="13"
                                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg 
                     focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none transition-all"
                                />
                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
                                  years
                                </span>
                              </div>
                              <ErrorMessage
                                name="target_audience_age"
                                component="div"
                                className="text-red-600 text-xs mt-1"
                              />
                            </div>

                            {/* Local Radius */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                Delivery Radius
                              </label>
                              <div className="relative">
                                <input
                                  type="number"
                                  name="location_radius"
                                  placeholder="e.g. 2"
                                  value={values.location_radius || ""}
                                  onChange={handleChange}
                                  min="1"
                                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg 
                     focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none transition-all"
                                />
                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
                                  km
                                </span>
                              </div>
                              <ErrorMessage
                                name="location_radius"
                                component="div"
                                className="text-red-600 text-xs mt-1"
                              />
                            </div>

                            {/* Gender */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                Gender
                              </label>
                              <select
                                name="gender"
                                value={values.gender || "All"}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   outline-none bg-white transition-all appearance-none"
                                style={{
                                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E")`,
                                  backgroundPosition: "right 0.75rem center",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "1.5em",
                                }}
                              >
                                <option value="All">All Genders</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Others">Others</option>
                              </select>
                              <ErrorMessage
                                name="gender"
                                component="div"
                                className="text-red-600 text-xs mt-1"
                              />
                            </div>
                          </div>

                          {/* Optional small helper text */}
                          <div className="mt-5 text-xs text-gray-500 flex items-center gap-2">
                            <svg
                              className="w-4 h-4 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span>
                              These filters help target users more precisely
                              within your existing audience.
                            </span>
                          </div>
                        </div>
                      )}

                      {/* Daily Budget */}
                      <div className="mt-6">
                        <div className="flex justify-between">
                          <Lable lable="Daily Budget" />
                          <button
                            type="button"
                            onClick={() => setDailyBudgetEditable(!dailyBudgetEditable)}
                            className="px-4 py-1 text-sm border border-red-600 rounded hover:bg-gray-100"
                          >
                            Change Daily Budget
                          </button>
                        </div>
                        <p className="text-xl font-medium">
                          ₵{values.advertisement_budget}
                        </p>
                        <input
                          name="advertisement_budget"
                          type="range"
                          min="0"
                          max="100000"
                          step="100"
                          value={values.advertisement_budget}
                          onChange={handleChange}
                          disabled={!dailyBudgetEditable}
                          className="w-full mt-1"
                        />
                      </div>

                      {/* Remaining Budget + Recharge */}
                      <div className="mt-6">
                        <div className="flex justify-between">
                          <Lable lable="Remaining Budget" />
                          <button
                            type="button"
                            onClick={() => setRemainingBudgetEditable(!remainingBudgetEditable)}
                            className="px-4 py-1 text-sm border border-red-600 rounded hover:bg-gray-100"
                          >
                            Recharge
                          </button>
                        </div>
                        <p className="text-xl font-medium">
                          ₵{values.remaining_budget}
                        </p>
                        <input
                          name="remaining_budget"
                          type="range"
                          min="0"
                          max="100000"
                          step="100"
                          value={values.remaining_budget}
                          onChange={handleChange}
                          disabled={!remainingBudgetEditable}
                          className="w-full mt-1"
                        />
                      </div>

                      {values?.remaining_budget && (
                        <p className="flex flex-col items-end justify-end text-lg my-2">
                          <span>Tax: ${values?.advertisement_tax}</span>
                          <span>
                            Total Cost: $
                            {values?.remaining_budget +
                              values?.advertisement_tax}
                          </span>
                        </p>
                      )}

                      {singleAdd?._id ? (
                        <div className="flex justify-between px-4 py-2">
                          <span className="flex flex-col items-center justify-center">
                            <LuEye fontSize={"1.5rem"} />
                            <span>{singleAdd?.advertise_views}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <GiClick fontSize={"1.5rem"} />
                            <span>{singleAdd?.click_count}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <MdOutlineShoppingCart fontSize={"1.5rem"} />
                            <span>{singleAdd?.addToCart_count}</span>
                          </span>
                          <span className="flex flex-col items-center justify-center">
                            <MdDownloadDone fontSize={"1.5rem"} />
                            <span>{singleAdd?.ordered_by_advertise}</span>
                          </span>
                          {/* <span className="flex flex-col items-center justify-center">
                            <PiShareFat fontSize={"1.5rem"} />
                            <span>{singleAdd?.share}</span>
                          </span> */}
                        </div>
                      ) : null}
                      {/* More icons here */}
                    </div>
                    {singleAdd?.product ? (
                      <>
                        <hr className="py-1" />
                        <div style={{ height: "10rem" }}>
                          <Line
                            ref={chartRef}
                            data={data}
                            options={options}
                            className="p-2"
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                </SidebarField>
              </Form>
            )}
          </Formik>
        )}
        <DeleteFieldModal
          isOpen={deleteModal}
          onClose={handleDeleteClose}
          onDelete={() => handleDelete()}
        />
      </div>
    </div>
  );
}

export default PromoManagement;
